import { TrashIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Trash = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', ...rest } = props;

  return <TrashIcon {...rest} size={Sizes[size]} color={fill} />;
};

Trash.displayName = 'Trash';
